export class EnumTranslator {
  static getEnumValueTranslated(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'boolean': return 'Booleano';
      case 'correlationkey': return 'Chave de correlação';
      case 'date': return 'Data';
      case 'floating': return 'Ponto flutuante';
      case 'integer': return 'Inteiro';
      case 'none': return 'Nenhum';
      case 'text': return 'Texto';
      default: return `Não identificado (${enumName})`;
    }
  }

  static getEnumDateType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'datetime': return 'Data e Hora';
      case 'dateonly': return 'Apenas Data';
      case 'monthyear': return 'Mês e Ano';
      default: return `Não identificado (${enumName})`;
    }
  }

  static getEnumFieldDomainType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'fixed': return 'Fixo';
      case 'dynamic': return 'Dinâmico';
      case 'definedinflow': return 'Fluxo de Tela';
      default: return `Não identificado (${enumName})`;
    }
  }

  static getEnumFieldValidator(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'nenhum': return 'Nenhum';
      case 'aomenos2palavras': return 'AOMENOS2PALAVRAS';
      case 'beneficioprevidencia': return 'BeneficioPrevidencia';
      case 'cep': return 'CEP';
      case 'chassi': return 'CHASSI';
      case 'cmc7': return 'CMC7';
      case 'cnpj': return 'CNPJ';
      case 'cpf': return 'CPF';
      case 'data': return 'DATA';
      case 'datafutura': return 'DataFutura';
      case 'inscricaoestadual': return 'InscricaoEstadual';
      case 'letraenumero': return 'LetraENumero';
      case 'longpositivo': return 'LONGPOSITIVO';
      case 'modulo11': return 'MODULO11';
      case 'numautorizacaoanvisa': return 'NumAutorizacaoAnvisa';
      case 'placa': return 'PLACA';
      case 'renavam': return 'RENAVAM';
      case 'somentealgarismo': return 'SOMENTEALGARISMO';
      default: return `Não identificado (${enumName})`;
    }
  }

  static getEnumMaskType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'cpf': return 'CPF';
      case 'cnpj': return 'CNPJ';
      case 'twodecimalplaces': return '2 Casas Decimais';
      case 'fourdecimalplaces': return '4 Casas Decimais';
      case 'eightdecimalplaces': return '8 Casas Decimais';
      case 'phonenumber': return 'Telefone';
      default: return `Não identificado (${enumName})`;
    }
  }

  static getEnumNodeType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'agent': return 'Agent';
      case 'runtime': return 'Runtime';
      case 'api': return 'Api';
      case 'webclient': return 'Web Client';
      case 'ldap': return 'Ldap';
      case 'batchwatcher': return 'Monitor de lote';
      case 'scheduler': return 'Agendador';
      case 'inmemory': return 'Centralizador de Dados';
      case 'batcher': return 'Batcher';
      default: return enumName;
    }
  }

  static getEnumMetadataType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'integer': return 'Inteiro';
      case 'date': return 'Data';
      case 'text': return 'Texto';
      case 'floating': return 'Ponto flutuante';
      default: return enumName;
    }
  }

  static getEnumMetadataEditingType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'flow': return 'Fluxo de sistema';
      case 'user': return 'Usuário';
      case 'pool': return 'Pool';
      default: return enumName;
    }
  }
  
  static getEnumDataExtractionType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'fixed': return 'Fixo';
      case 'filelayout': return 'Layout de arquivo';
      // case 'batchFileLayout': return '';
      default: return enumName;
    }
  }
  
  static getEnumDataExtractionIntervalType(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'fixedrange': return 'Período Fixo';
      case 'incremental': return 'Incremental';
      case 'retroactive': return 'Retroativo';
      default: return enumName;
    }
  }

  static getEnumTaskLogStatus(enumName: string) {
    switch (enumName.toLowerCase()) {
      case 'none': return 'Nenhum';
      case 'succeeded': return 'Finalizado';
      case 'canceled': return 'Cancelado';
      case 'failed': return 'Falha';
      case 'running': return 'Executando';
      default: return enumName;
    }
  }
}
